import type { KlpTypographyVariant } from './IKlpStyles';

export type IKlpFontVariant = {
    [variant in KlpTypographyVariant]: {
        fontSize: string;
        lineHeight: string;
    };
};

export const KlpFontVariant = {
    default: {
        fontSize: '1.1875rem',
        lineHeight: '1.6875rem',
    },
    base: {
        fontSize: '1.1875rem',
        lineHeight: '1.6875rem',
    },
    xsmall: {
        fontSize: '0.875rem',
        lineHeight: '1.3rem',
    },
    small: {
        fontSize: '1rem',
        lineHeight: '1.3rem',
    },
    epsilon: {
        fontSize: '1.3125rem',
        lineHeight: '1.875rem',
    },
    delta: {
        fontSize: '1.5rem',
        lineHeight: '2.0625rem',
    },
    gamma: {
        fontSize: '1.625rem',
        lineHeight: '2.25rem',
    },
    beta: {
        fontSize: '1.75rem',
        lineHeight: '2.4375rem',
    },
    alpha: {
        fontSize: '1.875rem',
        lineHeight: '2.4375rem',
    },
};
